export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.statistics': '统计分析',
  'menu.statistics.overview': '统计概览',
  'menu.statistics.player': '用户统计',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.finance': '财务管理',
  'menu.finance.app-accounts': 'App收款账号',
  'menu.finance.deposits': '充值列表',
  'menu.finance.withdraws': '提现列表',
  'menu.finance.crypto-recharges': '虚拟币充值',
  'menu.finance.crypto-withdraws': '虚拟币提款',
  'menu.finance.payment-records': '收款记录',
  'menu.finance.app-platforms': '提现平台管理',
  'menu.users': '用户管理',
  'menu.users.list': '用户列表',
  'menu.users.agent-change-records': '代理商变更记录',
  'menu.users.rolling-management': 'Rolling管理',
  'menu.system-management': '系统管理',
  'menu.system-management.overview': '系统总览',
  'menu.system-management.messages': '系统消息',
  'menu.system-management.announcements': '公告管理',
  'menu.system-management.agent-popups': '代理后台弹窗公告',
  'menu.system-management.marquee': '跑马灯管理',
  'menu.system-management.maintenance': '维护管理',
  'menu.game-management': '游戏管理',
  'menu.game-management.robot-config': '机器人配置',
  'menu.game-management.promotion-bots': '推广机器人',
  'menu.game-management.robot-management': '机器人管理',
  'menu.game-management.game-stats': '游戏统计',
  'menu.game-management.shan-rooms': 'Shankoemee房间',
  'menu.game-management.boogyi-rooms': 'Boogyi房间',
  'menu.game-management.shankoemee-history': 'ShanKoeMee游戏日志',
  'menu.game-management.boogyi-history': 'Boogyi游戏日志',
  'menu.game-management.tinyskm-history': 'TinySKM游戏日志',
  'menu.game-management.jili-history': 'JILI游戏日志',
  'menu.游戏管理.pragmatic-history': 'PP游戏日志',
  'menu.数据记录': '数据记录',
  'menu.数据记录.transaction-history': '金额变动记录',
  'menu.数据记录.login-history': '用户登录记录',
  'menu.数据记录.daily-stats': '每日统计数据',
  'menu.数据记录.金额变动记录': '金额变动记录',
  'menu.数据记录.用户登录记录': '用户登录记录',

  // 推荐人管理
  'menu.推荐人管理': '推荐人管理',
  'menu.推荐人管理.推荐人统计': '推荐人统计',
  'menu.推荐人管理.返利记录': '返利记录',
  'menu.推荐人管理.转换记录': '转换记录',
  'menu.推荐人管理.待处理返利': '待处理返利',
  'menu.推荐人管理.系统配置': '系统配置',

  // 系统管理
  'menu.系统管理': '系统管理',
  'menu.系统管理.系统总览': '系统总览',
  'menu.系统管理.系统消息': '系统消息',
  'menu.系统管理.公告管理': '公告管理',
  'menu.系统管理.代理后台弹窗公告': '代理后台弹窗公告',
  'menu.系统管理.活动管理': '活动管理',
  'menu.系统管理.跑马灯管理': '跑马灯管理',
  'menu.系统管理.维护管理': '维护管理',
  'menu.系统管理.虚拟币配置': '虚拟币配置',
  'menu.系统管理.用户币种地址': '用户币种地址',
  'menu.系统管理.Telegram群发': 'Telegram群发',
  'menu.系统管理.消息模板': '消息模板',

  // 代理管理
  'menu.代理管理': '代理管理',
  'menu.代理管理.代理商管理': '代理商管理',
  'menu.代理管理.代理商充值': '代理商充值',
  'menu.代理管理.代理商提现': '代理商提现',
  'menu.代理管理.金额变动记录': '金额变动记录',
  'menu.代理管理.代理-天统计': '代理-天统计',
  'menu.代理管理.代理-按游戏天统计': '代理-按游戏天统计',

  // 游戏管理
  'menu.游戏管理': '游戏管理',
  'menu.游戏管理.机器人配置': '机器人配置',
  'menu.游戏管理.Shankoemee房间': 'Shankoemee房间',
  'menu.游戏管理.Boogyi房间': 'Boogyi房间',
  'menu.游戏管理.ShanKoeMee游戏日志': 'ShanKoeMee游戏日志',
  'menu.游戏管理.Boogyi游戏日志': 'Boogyi游戏日志',

  // Statistics
  'stats.date': '日期',
	'stats.username': '玩家账号',
  'stats.userId': '用户ID',
  'stats.totalBet': '总下注',
  'stats.totalPayout': '总派彩',
  'stats.gameRevenue': '游戏收益',
  'stats.rechargeAmount': '充值金额',
  'stats.withdrawAmount': '提现金额',
  'stats.rechargeCount': '充值次数',
  'stats.withdrawCount': '提现次数',
  'stats.dateRange': '日期范围',
  'stats.playerDailyStats': '用户每日统计',
  'stats.activeUsers': '活跃用户',
  'stats.totalRecharge': '总充值',
  'stats.totalWithdraw': '总提现',
  'stats.netRevenue': '净收益',
  'stats.totalCommission': '总佣金',
  'stats.financeChart': '财务趋势',
  'stats.revenueChart': '收益趋势',
  'stats.recharge': '充值',
  'stats.withdraw': '提现',
  'stats.fetchError': '获取统计数据失败',
  'common.today': '今天',
  'common.yesterday': '昨天',
  'common.last7days': '近7天',
  'common.last30days': '近30天',
  'common.thisMonth': '本月',
  'common.query': '查询',
};
